import errorCone from '../../../../../../../assets/errorCone.svg';
import { useCustomTranslation } from '../../../../../../hooks';
import { Drawer } from '@nexelem/drawer';

export const DrawerEmptyState = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.emptyState');

  return (
    <Drawer>
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <div
          className="h-60 w-[35%] bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${errorCone})` }}
        />
        <span className="text-s18 text-text-secondary">{tWrapper('noTask')}</span>
      </div>
    </Drawer>
  );
};
